import React from "react";
import {
  Box,
  Button,
  Typography,
  FormControl,
  Select,
  MenuItem,
} from "@mui/material";
import { useTranslation } from "react-i18next";

const Question = ({
  question,
  index,
  answers,
  selectedOptions,
  options,
  handleAnswer,
  handleSelectChange,
  t,
}) => {
  const answer = answers[question.id];

  return (
    <Box key={question.id} sx={{ marginBottom: 2 }}>
      <Typography variant="h6">
        Question {index + 1}: {question.text}
      </Typography>

      <Box>
        {["Yes", "No"].map((option) => (
          <Button
            key={option}
            variant={answer === option ? "contained" : "outlined"}
            color={answer === option ? "primary" : "inherit"}
            onClick={() => handleAnswer(question.id, option)}
            sx={{ marginRight: 1 }}
          >
            {t(`dashboard.decision-tree.buttons.${option.toLowerCase()}`)}
          </Button>
        ))}
      </Box>

      {answer === "Yes" && question.requiresDropdown && (
        <FormControl fullWidth sx={{ marginTop: 1 }}>
          <Select
            value={selectedOptions[question.id] || ""}
            onChange={(e) => handleSelectChange(question.id, e.target.value)}
            displayEmpty
            renderValue={(selected) =>
              selected ? (
                t(
                  `dashboard.decision-tree.options.${
                    findObjectByLabel(question?.options, selected)
                      ?.translationKey
                  }`,
                  {
                    defaultValue: selected,
                  }
                )
              ) : (
                <em>
                  {t("dashboard.decision-tree.selectOption", {
                    defaultValue: "Select an option",
                  })}
                </em>
              )
            }
          >
            {options[question.id]?.length > 0 ? (
              options[question.id].map((option, idx) => (
                <MenuItem key={idx} value={option.label}>
                  {t(
                    `dashboard.decision-tree.options.${option?.translationKey}`,
                    {
                      defaultValue: option.label,
                    }
                  )}
                </MenuItem>
              ))
            ) : (
              <MenuItem disabled>
                {t("dashboard.decision-tree.options.notAvailable", {
                  defaultValue: "Not Available",
                })}
              </MenuItem>
            )}
          </Select>
        </FormControl>
      )}
    </Box>
  );
};

export default Question;

function findObjectByLabel(data, label) {
  if (!data) return null;
  return data.find((item) => item.label === label);
}
